// extracted by mini-css-extract-plugin
export var event = "event-module--event--1mZ_c";
export var event__title = "event-module--event__title--2j0Wi";
export var event__meta = "event-module--event__meta--3S8Db";